import { NgModule } from '@angular/core';

import { KoppelcodeInvoerenModule } from '../koppelcode-invoeren/koppelcode-invoeren.module';

import { RetailKoppelcodeInvoerenComponent } from './retail-koppelcode-invoeren.component';

@NgModule({
    imports: [KoppelcodeInvoerenModule],
    exports: [RetailKoppelcodeInvoerenComponent],
    declarations: [RetailKoppelcodeInvoerenComponent],
    bootstrap: [RetailKoppelcodeInvoerenComponent]
})
export class RetailKoppelcodeInvoerenModule {}
